namespace GeniuzPOS.InitialData {
    export enum PsPosStationEnumCashierPosFg {
        CashierPosFg = 0,
        CashierPosFg1 = 1
    }
    Serenity.Decorators.registerEnumType(PsPosStationEnumCashierPosFg, 'GeniuzPOS.InitialData.PsPosStationEnumCashierPosFg');
}
